import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import { ENUM_ROUTES } from "../../RoutesEnum";
import { useLazyGetPointsQuery } from "../../services/loyaltyPoint";
import { showError } from "../../constants/toasts";

const LoyaltyPointsTopBar = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [getPoint] = useLazyGetPointsQuery()
  const [PoitnsData, setPoitnsData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedId, setSelectedId] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const fetchPoints = async () => {
    try {
      const response = await getPoint({
        from: page,
        size: pageSize,
        search: searchTerm,
      }).unwrap();
      if (response?.statusCode === 200) {
        setPoitnsData(response.data.data || []);
        setTotalCount(response.data.total || 0);
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to fetch Loyalty Points");
    }
  };
  useEffect(() => {
    fetchPoints()
  }, [])
  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </Box>
        </div>
        <div className="right_s">
          {/* <Button className="btn btn_primary" onClick={() => navigate(ENUM_ROUTES.LOYALTY_POINTS_DETAILS)}><AddIcon /> Add</Button> */}
          <Button className="btn btn_grey"><DownloadIcon /> Export</Button>
        </div>
      </div>
    </>
  );
};

export default LoyaltyPointsTopBar;
